import React from "react";
import { Box } from "@chakra-ui/react";
import { PATH_PICK_SELECTION_BAR_HEIGHT_VAR } from "@/features/pathpick/constants";

// 하단 플로팅 선택 바는 fixed라 자리를 차지하지 않아, 끝까지 내려도 마지막 카드와
// "맨 위로" 버튼을 가린다. 목록 끝에 바 높이(실측) + 바와 페이지네이션 사이 간격만큼 비운다.
// 간격 = 바의 bottom − 페이지네이션 높이 + 8px (모바일 98 − 96, PC 88 − 56 — PATH_PICK_SELECTION_BAR_BOTTOM).
// 선택이 있어 바가 떠 있을 때만 렌더한다.
function PathPickSelectionBarSpacer() {
  return (
    <Box
      height={{
        base: `calc(var(${PATH_PICK_SELECTION_BAR_HEIGHT_VAR}, 0px) + 10px)`,
        md: `calc(var(${PATH_PICK_SELECTION_BAR_HEIGHT_VAR}, 0px) + 40px)`,
      }}
    />
  );
}

export default PathPickSelectionBarSpacer;
